import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
const baseUrl = environment["baseUrl"];
@Injectable({
  providedIn: 'root'
})
export class LoginapiService {
  constructor(private http: HttpClient, private router: Router) { }
     /* Method which makes API call to login */
     login(body: any): Observable<any> {
      return this.http.post(`${baseUrl}accounts/login`, body).pipe(
        map(
          (response: any) => {
        //     const cookies = response.headers.get('Set-Cookie');
        // console.log(cookies);
            return response;
          },
          (err: any) => {
            console.log(err);
          }
        )
      );
    }
    /* Method which makes API call to verify the email */
    verifyEmail(body: any): Observable<any> {
      return this.http.post(`${baseUrl}accounts/otp_generator`, body).pipe(
        map(
          (response: any) => {
            return response;
          },
          (err: any) => {
            return err
            console.log(err);
          }
        )
      );
    }
     /* Method which makes API call to verify the otp */
     otpverifyEmail(body: any): Observable<any> {
      return this.http.post(`${baseUrl}accounts/otp_verification`, body).pipe(
        map(
          (response: any) => {
            return response;
          },
          (err: any) => {
            console.log(err);
          }
        )
      );
    }
     /* Method which makes API call to update the password */
     updatePassword(body: any): Observable<any> {
      return this.http.put(`${baseUrl}accounts/reset_password`, body).pipe(
        map(
          (response: any) => {
            return response;
          },
          (err: any) => {
            console.log(err);
          }
        )
      );
    }
    logout(logoutMessage: { message: string }): Observable<any> {
      return this.http.post(
        `${baseUrl}accounts/logout`,
        logoutMessage
      );
    }
}
